"use client";
import UserServices from "@/services/main/UserServices";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { User } from "@/models/user";
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { useTranslations } from "next-intl";
export interface OrganizationForm {
  userId: number | string;
  isContinue?: boolean;
  phone: string;
  company: string;
  title: string;
  code: string;
  isNewOrganization?: boolean;
  isJoinOrganization?: boolean;
}

interface IPopupOrganizationProps {
  user: User | null;
}
const PopupOrganization = ({ user }: IPopupOrganizationProps) => {
  const [open, setOpen] = React.useState(true);
  const t = useTranslations("messages");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = async () => {
    await UserServices.turnOffWarning();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: "form",
          sx: {
            maxWidth: "600px",
            width: "100%",
          },
        },
      }}
    >
      <DialogTitle component={"div"} sx={{
        paddingTop: "16px",
        paddingRight: "24px",
        paddingBottom: "16px",
        paddingLeft: "24px",
        display: "flex",
        gap: 2,
        alignItems: "center",
      }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#D1FADF",
            borderRadius: "2%",
            width: 32,
            height: 32,
          }}
        >
          <DoneIcon sx={{ color: "#12B76A", fontSize: 28 }} />
        </Box>
        <Typography sx={{
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "24px",
          padding: "0px",
          fontFamily: "Montserrat, sans-serif"
        }}
          translation-key="organization_success_title"
        >{t("organization_success_title")} </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 16,
          top: 10,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{
        padding: "24px 24px 24px 24px",
      }}>
        <Typography sx={{
          fontSize: "18px",
          fontWeight: 500,
          lineHeight: "20px",
          color: "var(--gray-90)",
          fontFamily: "Montserrat, sans-serif"
        }}
          translation-key="organization_success_description"
        >
          {t("organization_success_description")}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default PopupOrganization;
